// src/pages/settings/PriceLevels.jsx
import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import api from '../../config/api';
import { Header, Modal, Field, Actions, asArray } from './SettingsUI';

export default function PriceLevels() {
  const { t } = useTranslation();
  const qc = useQueryClient();
  const [editing, setEditing] = useState(null);

  const { data: list = [], isLoading } = useQuery(['price-levels'], () =>
    api.get('/api/price-levels').then((r) => asArray(r.data)));

  const save = useMutation(
    (b) => b._id ? api.put(`/api/price-levels/${b._id}`, b) : api.post('/api/price-levels', b),
    { onSuccess: () => { qc.invalidateQueries(['price-levels']); setEditing(null); }, onError: (e) => alert(e?.response?.data?.message || e.message) });
  const del = useMutation((id) => api.delete(`/api/price-levels/${id}`),
    { onSuccess: () => qc.invalidateQueries(['price-levels']), onError: (e) => alert(e?.response?.data?.message || e.message) });

  return (
    <div className="p-5">
      <Header title={t('settings.priceLevels', 'Price Levels')} onAdd={() => setEditing({})} addLabel={t('common.add', 'Add')} />
      {isLoading ? <div className="text-gray-400 py-8">…</div> : !list.length ? <div className="text-gray-400 py-8">{t('common.none', 'Nothing yet')}</div> : (
        <div className="bg-white rounded-xl border overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-gray-500"><tr>
              <th className="text-start px-4 py-2">{t('common.nameEn', 'Name (EN)')}</th>
              <th className="text-start px-4 py-2">{t('common.nameAr', 'Name (AR)')}</th>
              <th className="px-4 py-2 w-28"></th>
            </tr></thead>
            <tbody>
              {list.map((r) => (
                <tr key={r._id} className="border-t">
                  <td className="px-4 py-2 font-semibold">{r.name_en}</td>
                  <td className="px-4 py-2" dir="rtl">{r.name_ar}</td>
                  <td className="px-4 py-2 text-end whitespace-nowrap">
                    <button onClick={() => setEditing(r)} className="text-blue-600 font-semibold me-3">{t('common.edit', 'Edit')}</button>
                    <button onClick={() => window.confirm(t('common.confirmDelete', 'Delete this item?')) && del.mutate(r._id)} className="text-red-600 font-semibold">{t('common.delete', 'Delete')}</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {editing && <PLForm row={editing} t={t} busy={save.isLoading} onClose={() => setEditing(null)} onSave={(b) => save.mutate(b)} />}
    </div>
  );
}

function PLForm({ row, onClose, onSave, busy, t }) {
  const [f, setF] = useState({ name_en: row.name_en || '', name_ar: row.name_ar || '' });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <Modal title={row._id ? t('common.edit', 'Edit') : t('common.add', 'Add')} onClose={onClose}>
      <div className="space-y-3">
        <Field label={t('common.nameEn', 'Name (EN)')}><input value={f.name_en} onChange={set('name_en')} className="inp" /></Field>
        <Field label={t('common.nameAr', 'Name (AR)')}><input value={f.name_ar} onChange={set('name_ar')} className="inp" dir="rtl" /></Field>
        <Actions busy={busy} disabled={!f.name_en} onClose={onClose} onSave={() => onSave({ ...row, ...f })}
                 cancelLabel={t('common.cancel', 'Cancel')} saveLabel={t('common.save', 'Save')} savingLabel={t('common.saving', 'Saving…')} />
      </div>
    </Modal>
  );
}